/**
 * User: Faris
 * Date: 6/24/13
 * Time: 11:22 AM
 */

define('app/router',[],function(){

  return Backbone.Router.extend({

    routes: {
      '*page' : 'onRouteChanged'
    },

    initialize: function(){
      $('body').on("click", "a:internal:not(.no-ajaxy)", function(e){
        var href = $(this).attr('href');
        if(!href || typeof href == 'undefined' || href == ''){
          return true;
        }

        // Continue as normal for cmd clicks etc
        if (e.which == 2 || e.metaKey || $(this).attr('target') == '_blank') {
          return true;
        }

        var url = $(this).attr("href").replace(SITE_ROOT, '');

        Backbone.history.navigate(url, { trigger:true });

        e.preventDefault();

        return false;
      });
    },

    onRouteChanged: function(){
      this.trigger('routeChanged', Backbone.history.fragment);
    }

  });

});
